import React from "react"
import { Link } from "gatsby"
import phonesmartcards from "../../../images/licence-open.png"
import thumb from "../../../images/thumb.png"
import StaticVideo from "../../Video/StaticVideo"
import "./BeanoAppsDowntime.scss"
import PosterImage from "./../../../images/video-3-poster.png"
import Transcript from "./../../../images/Downloading-Apps-and-Games-Safely-Transcript.pdf"

const BeanoAppsDowntime = () => {
	return (
		<div className="phonesmart-cards learning app-downtime">
			<div className="container">
				<div className="row">
					<div className="col-12 col-md-6">
						{/* <img src={phonesmartcards} className="PhoneSmart Licence" alt="PhoneSmart Licence"/> */}
						<div className="video-box-bg text-center">
							<StaticVideo videoId="Y09slPml8NQ" poster={PosterImage} transcript={Transcript} engagement={"Grown-up Homepage"}/>
						</div>
					</div>
					<div className="col-12 col-md-6">
						<h2 className="h1">APPS AND DOWNTIME</h2>
						<h4>Downloading apps and games – watch with your kids then share these great tips:</h4>
						<ol>
							<li>Apps have a minimum age limit, while games have a PEGI rating so you can see if it’s appropriate for you. The age rating can be found listed where you downloaded the app, and a game’s PEGI rating can be found on the PEGI website <a href="https://pegi.info/" target="_blank" >www.pegi.info</a>.</li>
							<li>It’s easy to lose track of time, so set reminders to take a break using your phone’s timer.</li>
							<li>Give your eyes and brain a rest. You can see how long you’ve spent on an app in your screentime settings.</li>
							<li>Go to settings and turn off notifications when it’s time to get some sleep.</li>
						</ol>
						{/* <p>Give your kids an even better start online with the EE PhoneSmart Licence.</p> */}
						{/* <div className="text-center"><img alt="sticker thumb" className="thumb" src={thumb}></img></div> */}
					</div>
				</div>
			</div>
		</div>
	)
}

export default BeanoAppsDowntime
